import { createContext, useContext } from 'react';
import { TFlowLayoutContentProps } from './components/FlowLayoutStep/FlowLayoutStep';

export type TFlowLayoutContext = {
  currentStep: number;
  updateFlow: (props: Omit<TFlowLayoutContentProps, 'children'>) => void;
  goNext: () => void;
  goBack: () => void;
  dismiss: () => void;
};

export const FlowLayoutContext = createContext<TFlowLayoutContext>({
  currentStep: 0,
  updateFlow: () => {},
  goNext: () => {},
  goBack: () => {},
  dismiss: () => {},
});

export const useFlowLayout = () => {
  const context = useContext(FlowLayoutContext);
  if (!context) {
    throw new Error('useFlowLayout must be used within a FlowLayout');
  }
  return context;
};
